import type { CSSProperties } from "react"

export default function IconChevronDown({
  className,
  style,
}: {
  className?: string
  style?: CSSProperties
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 21 23"
      fill="none"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.2737 8.02215C4.1908 8.05372 4.08049 8.15906 4.03602 8.24907C4.00619 8.30952 3.99978 8.34412 4.00001 8.44334C4.00027 8.54479 4.0065 8.57617 4.03913 8.63956C4.06835 8.6964 4.81057 9.4725 7.04456 11.7823L10.0112 14.8495L10.1384 14.9109C10.3843 15.0297 10.6157 15.0297 10.8616 14.9109L10.9888 14.8495L13.9554 11.7823C16.1894 9.4725 16.9316 8.6964 16.9609 8.63956C16.9935 8.57617 16.9997 8.54479 17 8.44334C17.0002 8.34412 16.9938 8.30952 16.964 8.24907C16.9161 8.15203 16.8066 8.05194 16.7134 8.01988C16.6156 7.98628 16.4699 7.99621 16.3801 8.04256C16.3322 8.06735 15.5328 8.88467 13.4072 11.0823L10.5 14.0882L7.59276 11.0823C5.47968 8.89758 4.66758 8.06715 4.61985 8.04233C4.53492 7.99816 4.36297 7.98811 4.2737 8.02215Z"
        fill="currentColor"
      />
    </svg>
  )
}
